module.exports = __webpack_public_path__ + "media/lose.d260de2e.mp3";